import { render, staticRenderFns } from "./TheFacilitiesKeyLockEditForm.vue?vue&type=template&id=60051736&"
import script from "./TheFacilitiesKeyLockEditForm.vue?vue&type=script&lang=js&"
export * from "./TheFacilitiesKeyLockEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports